
import { useEffect, useRef, useState } from 'react';

export default function MobileFirst() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="relative py-32 px-8 bg-white"
    >
      <div className="max-w-[1200px] mx-auto">
        <div
          className={`text-center space-y-8 transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
          }`}
        >
          <h2 className="text-[#09090b] text-[56px] font-bold leading-tight">
            Built for How You Actually Work
          </h2>

          <div className="max-w-[800px] mx-auto space-y-6 text-[#52525b] text-[18px] leading-relaxed">
            <p>
              Other legal AI tools are desktop-bound. Big screens. Corner offices.
            </p>

            <p>
              You're in the courthouse hallway with five minutes. You're between depositions. You're at your kid's soccer game when opposing counsel files something absurd.
            </p>

            <p className="text-[#09090b] font-medium text-[20px]">
              HushLegal is a mobile app breakthrough. Dictate, generate, and file from anywhere with a signal.
            </p>

            <p className="text-[#8B4513] font-semibold text-[22px]">
              This is what every lawyer has been waiting for
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
